<template>
  <div class="police_detail">
    <common-detail
      :title="detail.title"
      :imgList="detail.consultPictures"
    ></common-detail>
  </div>
</template>

<script>
import { getPolicyDetail } from "@/api/home.js";
export default {
  name: "PoliceDetail",
  data() {
    return {
      detail: {}
    };
  },
  methods: {
    async PolicyDetail() {
      const { data } = await getPolicyDetail(this.$route.query.id);
      this.detail = data;
    }
  },
  mounted() {
    this.PolicyDetail();
    window.document.title = this.$route.query.title;
  }
};
</script>

<style lang="scss" scoped></style>
